import { Link } from "react-router-dom";
import { Globe } from "lucide-react";

const Footer = () => {
  return (
    <footer className="py-12 px-4 md:px-8 border-t border-border/50 bg-muted/20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <Globe className="h-5 w-5 text-primary" />
              <span className="font-bold font-['Manrope']">Nomad Roadmap</span>
            </div>
            <p className="text-xs text-muted-foreground leading-relaxed max-w-xs">
              Your roadmap to life abroad. Helping US citizens find, track, and apply for long-stay visas.
            </p>
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-3">
              <h4 className="text-sm font-semibold">Product</h4>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li><Link to="/pricing" className="hover:text-primary">Pricing</Link></li>
                <li><Link to="/results" className="hover:text-primary">Explore Visas</Link></li>
              </ul>
            </div>
            <div className="space-y-3">
              <h4 className="text-sm font-semibold">Legal</h4>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li><Link to="/terms" className="hover:text-primary">Terms of Service</Link></li>
                <li><Link to="/privacy" className="hover:text-primary">Privacy Policy</Link></li>
              </ul>
            </div>
          </div>

          <div className="text-sm text-muted-foreground space-y-2">
            <p className="font-medium text-foreground">Disclaimer</p>
            <p className="text-xs">
              Nomad Roadmap is not a law firm and does not provide legal advice. We do not guarantee visa approval. Always verify with official government sources.
            </p>
            <p className="text-xs pt-4">
              © 2026 Nomad Roadmap. Built with love for the nomad community.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
